import { IconSearch, InputTypeTextReduced } from '@gmg/gmg-react-components';
import { ChangeEvent, FC } from 'react';
import { useTranslation } from 'react-i18next';

export interface SearchBoxProps {
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
    value: string;
}

const SearchBox: FC<SearchBoxProps> = (props) => {
    const { t } = useTranslation();

    return (
        <InputTypeTextReduced
            icon={<IconSearch/>}
            width="228px"
            placeholder={t('Common.SearchBox', 'Filter here ...')}
            error={false}
            {...props}
        />
    );
};

export default SearchBox;